import DropdownWithCta from '@core/components/dropdowns/dropdown-with-cta/dropdown-with-cta';
import Utils from '@core/base/scripts/utils/utils';

export default class SwitchLang extends DropdownWithCta {

  init(navBar) {
    super.init();
    this.navBar = navBar;
  }


  open(e) {
    super.open(e);
    if (Utils.isTablet) {
      this.navBar.setFocusables(this.$wrapper);
    }
  }

  close(e) {
    super.close(e);
    if (Utils.isTablet) {
      this.navBar.setFocusables(this.$wrapper);
    }
  }
}
